import { readItems } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../services/directusClient/directusClient.ts';

export const useEventDetailsItemsQuery = () =>
  useQuery({
    queryKey: ['event_details'],
    queryFn: () => directusClient.request(readItems('event_details')),
  });
